import LoginApp from "authentication/LoginApp";
import ResetPasswordApp from "authentication/ResetPasswordApp";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const accountRoute: RouteObject = {
  path: "account",
  children: [{
    path: "signin",
    loader: () => viewModel,
    Component: LoginApp,
  }, {
    path: "ResetMyPassword",
    loader: () => viewModel,
    Component: ResetPasswordApp,
  }]
};